import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthLayout from '../Layouts/Authlayout';
import {
  LABEL_RETURN_LOGIN,
  FORGOT_PASSWORD_SUCCESS_TITLE,
  FORGOT_PASSWORD_MESSAGE_1,
  FORGOT_PASSWORD_MESSAGE_2,
  LABEL_CLICK_TO_RESEND
} from '../../constants/constant';
import '../Styles/login.css';
import type { ForogotPasswordResponse} from '../types/types';
import {
    forgotPassword
  } from 'src/services/forgotPasswordService';



export default function ForgotPasswordSuccess(): JSX.Element {
  
  
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email');

  
  const navigate = useNavigate();
 
console.log(email);
  const handleResendLink = () : void=> {    
    setLoading(true);
    const params={
        email:email
     };

     (email != null) && forgotPassword(JSON.stringify(params))
    .then((res: ForogotPasswordResponse) => {
        console.log(res);
        if (res.status === 200 && res.data.result == 1) {
            navigate(`/forgot-password-success?email=${email}`)
          } else {
           
            setLoading(false);
          }
    })
    .catch((error) => {
        setError(error);
        console.log('Error: ', error)})
    .finally(() => setLoading(false));


}

console.log(error);
  return (
    <AuthLayout>
      <img
                src="/assets/images/check-email.svg"
                alt="email"
                width={65}
                height={65}
                className="mx-auto mb-[20px]"
            />
            <h1 className="text-center text-[18px] font-bold text-muted mb-[15px]">
                {FORGOT_PASSWORD_SUCCESS_TITLE}
            </h1>
            <p className="text-subtitle text-center text-[14px] mb-10">
                {FORGOT_PASSWORD_MESSAGE_1}{" "}
                <span className="font-bold text-muted">{email}</span>{" "}
                {FORGOT_PASSWORD_MESSAGE_2}
            </p>

            <button
                disabled={loading}
                onClick={() => handleResendLink()}
                className="btn btn-block bg-gradient-to-b border-0 from-red to-[#D6242C] h-[45px] text-14 normal-case focus-visible:outline-none rounded-50 font-semibold hover:from-[#D6242C] hover:to-[#ED4B52] text-white disabled:btn-primary disabled:opacity-100 disabled:text-white"
            >
                {!loading ? (
                    `${LABEL_CLICK_TO_RESEND}`
                ) : (
                    <span className="loading loading-spinner loading-xs text-white"></span>
                )}
            </button>
            <div className="text-center  mt-[15px]">
                <a
                    href="/"
                    className="text-center text-muted underline hover:text-primary text-14 inline-block"
                >
                    {LABEL_RETURN_LOGIN}
                </a>
            </div>
    </AuthLayout>
  );
}
